module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "all-cars"
    }
  }, [_c('v-ws', {
    attrs: {
      "sendMessage": _vm.sendMessage
    },
    on: {
      "onopen": _vm.createVehicleAll,
      "vehicle_all": _vm.changeData,
      "vehicle_choose": _vm.changeHover
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "poit-map"
  }, [_c('el-checkbox-group', {
    staticClass: "summary",
    on: {
      "change": _vm.handleCheckedStatusChange
    },
    model: {
      value: (_vm.checkedStatus),
      callback: function($$v) {
        _vm.checkedStatus = $$v
      },
      expression: "checkedStatus"
    }
  }, [_c('label', {
    staticClass: "info"
  }), _vm._v(" "), _c('el-checkbox', {
    key: "0",
    staticClass: "alarm",
    attrs: {
      "label": "alarm"
    }
  }, [_vm._v(_vm._s('报警中：' + _vm.statusList[0] + '辆'))]), _vm._v(" "), _c('el-checkbox', {
    key: "1",
    staticClass: "running",
    attrs: {
      "label": "run"
    }
  }, [_vm._v(_vm._s('运行中：' + _vm.statusList[1] + '辆'))]), _vm._v(" "), _c('el-checkbox', {
    key: "2",
    staticClass: "stop",
    attrs: {
      "label": "stop"
    }
  }, [_vm._v(_vm._s('停止中：' + _vm.statusList[2] + '辆'))]), _vm._v(" "), _c('label', {
    staticClass: "total"
  }, [_vm._v("共" + _vm._s(_vm.carSum) + "辆")])], 1), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('div', {
    staticClass: "map"
  }, [_c('v-amap', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "map",
    attrs: {
      "poits": _vm.poits,
      "selectOne": _vm.selectOne
    },
    on: {
      "hover": _vm.hoverPoit
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1c6bcc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cars-location/all-cars.vue
// module id = 669
// module chunks = 1